module.exports = __webpack_public_path__ + "img/Accenture-logo.a7bc5643.png";